// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  
  	InstantSearchMobile.prototype.afterRender = function() {
      jQ('.boost-pfs-search-suggestion-mobile-top-panel input').addClass('snize-exclude-input');
    }

    // Start #165902
    InstantSearchApi.beforeCall = function(searchTerm) {
        /* Change the params before calling api */
        if(boostCustomSynonyms){
          var searchTermReformat = searchTerm.replace(/\*/g,'');
          var newSearchTerm = searchTermReformat;
          for(var i = 0; i < boostCustomSynonyms.length; i++){
            if(encodeURI(Object.keys(boostCustomSynonyms[i])[0]) == searchTermReformat){
              newSearchTerm = Object.values(boostCustomSynonyms[i])[0];
            }
          }
          Globals.instantSearchQueryParams['q'] = newSearchTerm;
        }
        //Globals.instantSearchQueryParams = ...;
    }
    // End #165902

})();